<template>
    <div class="frame-content-tab">
        <div class="frame-content-tab-wrap">
            <div class="filter">
                <div class="inline mr-8">
                    <el-input v-model="filters.subcontractor" clearable placeholder="分包单位" size="small"></el-input>
                </div>
                <div class="inline mr-8">
                    <el-select v-model="filters.payStatus" clearable placeholder="支付状态" size="small">
                        <el-option label="待支付" value="1"></el-option>
                        <el-option label="已支付" value="2"></el-option>
                    </el-select>
                </div>
                <div class="inline mr-8">
                    <el-select v-model="filters.intoStatus" clearable placeholder="入住状态" size="small">
                        <el-option label="已入住" value="1"></el-option>
                        <el-option label="已退宿" value="2"></el-option>
                    </el-select>
                </div>
                <div class="inline mr-8">
                    <el-date-picker
                        v-model="filters.payDate"
                        type="date"
                        placeholder="支付日期"
                        size="small">
                    </el-date-picker>
                </div>
                <div class="inline ml-8">
                    <el-button type="primary" size="small" icon="el-icon-search" @click="loadTable">查询</el-button>
                </div>
            </div>
            <div class="datatable-wrap mt-10">
                <div class="topbar">
                    <div class="inline">
                        <el-button type="primary" size="small" @click="handleExport">导出Excel</el-button>
                    </div>
                    <!-- <div class="inline ml-8">
                        <el-button type="danger" size="small" @click="handleDeleteAll">删除</el-button>
                    </div> -->
                </div>
                <div class="datatable">
                    <el-table
                        ref="curDepositReceiveTable"
                        :data="tableData"
                        v-loading="tableLoading"
                        element-loading-background="rgba(255, 255, 255, 0.3)"
                        border
                        style="width: 100%">
                        <el-table-column
                            type="selection"
                            width="55"
                            align="center">
                        </el-table-column>
                        <el-table-column
                            label="序号"
                            align="center"
                            width="80">
                            <template slot-scope="scope">
                                <span>{{ (pageNum - 1) * pageSize + scope.$index + 1}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="payStatus"
                            label="支付状态"
                            width="100">
                            <template slot-scope="scope">
                                <el-tag
                                    :type="scope.row.payStatus === 1 ? 'success' : 'warning'"
                                    disable-transitions>{{scope.row.payStatus === 1 ? '已支付' : '待支付'}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="subcontractor"
                            label="分包单位名称"
                            width="220">
                        </el-table-column>
                        <el-table-column
                            prop="intoStatus"
                            label="入住状态"
                            align="center"
                            width="100">
                            <template slot-scope="scope">
                                {{scope.row.intoStatus === 1 ? '已入住' : '已退宿' }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="depositItem"
                            align="center"
                            label="押金项目">
                        </el-table-column>
                        <el-table-column
                            prop="depositStandard"
                            align="center"
                            label="押金标准">
                        </el-table-column>
                        <el-table-column
                            prop="roomCount"
                            align="center"
                            label="宿舍数量">
                        </el-table-column>
                        <el-table-column
                            prop="money"
                            align="center"
                            label="金额">
                        </el-table-column>
                        <el-table-column
                            prop="payMoney"
                            align="center"
                            label="支付金额">
                        </el-table-column>
                        <el-table-column
                            prop="payMode"
                            align="center"
                            label="支付方式">
                        </el-table-column>
                        <el-table-column
                            prop="payDate"
                            align="center"
                            label="支付日期">
                        </el-table-column>
                        <el-table-column
                            prop="executor"
                            align="center"
                            label="操作人">
                        </el-table-column>
                        <el-table-column
                            prop="action"
                            label="操作"
                            align="center"
                            width="200">
                            <template slot-scope="scope">
                                <el-button
                                    v-if="scope.row.payStatus !== 1"
                                    size="mini"
                                    type="primary"
                                    @click="handleExport(scope.$index, scope.row)">押金登记</el-button>
                                <el-button
                                    v-if="scope.row.payStatus === 1"
                                    size="mini"
                                    type="primary"
                                    @click="handleExport(scope.$index, scope.row)">下载凭证</el-button>
                                <el-button
                                    v-if="scope.row.payStatus === 1"
                                    size="mini"
                                    type="primary"
                                    @click="handleExport(scope.$index, scope.row)">详情</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pagination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @curDepositReceive-change="handleCurDepositReceiveChange"
                        :background="true"
                        :curDepositReceive-page="pageNum"
                        :page-sizes="[50, 100, 200, 300, 400, 500]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalNum">
                    </el-pagination>
                </div>
            </div>

            <el-dialog
                title="详情"
                v-if="detailDialog.create"
                :visible.sync="detailDialog.visible"
                :close-on-click-modal="false"
                @closed="handleDetailClosed"
                class="custom-dialog big-dialog"><!-- big-dialog small-dialog mini-dialog  -->
                <DepositReceiveDetail :params="detailDialog.params"></DepositReceiveDetail>
            </el-dialog>

            <el-dialog
                title="添加"
                v-if="addDialog.create"
                :visible.sync="addDialog.visible"
                :close-on-click-modal="false"
                @closed="handleAddClosed"
                class="custom-dialog big-dialog"><!-- big-dialog small-dialog mini-dialog  -->
                <DepositReceiveAdd @done="handleAddDone"></DepositReceiveAdd>
            </el-dialog>
            
            <el-dialog
                title="编辑"
                v-if="editDialog.create"
                :visible.sync="editDialog.visible"
                :close-on-click-modal="false"
                @closed="handleEditClosed"
                class="custom-dialog big-dialog"><!-- big-dialog small-dialog mini-dialog  -->
                <DepositReceiveEdit :params="editDialog.params" @done="handleEditDone"></DepositReceiveEdit>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import common from '@/utils/common'
import http from '@/utils/http'
import DepositReceiveDetail from './DepositReceiveDetail'
import DepositReceiveAdd from './DepositReceiveAdd'
import DepositReceiveEdit from './DepositReceiveEdit'

export default {
    name: 'DemoDepositReceive',
    components: {
        DepositReceiveDetail,
        DepositReceiveAdd,
        DepositReceiveEdit
    },
    data() {
        return {
            filters: {
                subcontractor: '',
                payStatus: '',
                intoStatus: '',
                payDate: '',
            },

            tableData: [],

            totalNum: 0,
            pageNum: 1,
            pageSize: 50,

            tableLoading: false,

            detailDialog: {
                create: false,
                visible: false,
                params: {},
            },

            addDialog: {
                create: false,
                visible: false,
            },

            editDialog: {
                create: false,
                visible: false,
                params: {},
            },
        };
    },
    created () {
        this.loadTable();
    },
    methods: {
        ...common,
        // 加载表格数据
        loadTable() {
            let params = {...this.filters};

            params.pageNum = this.pageNum;
            params.pageSize = this.pageSize;

            this.tableLoading = true;
            http.get(http.MOCK_BASE_API_URL + 'v1/cost/deposit/receive/pageList', {
                params: params
            }).then(req => {
                this.tableLoading = false;
                if (req.data.code == http.SUCCESS) {
                    this.tableData = req.data.list;
                    this.totalNum = req.data.totalCount;
                } else {
                    this.showError(req.data.msg);
                }
            }).catch(err => {
                this.tableLoading = false;
                this.httpCatch(err);
            });
        },
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.loadTable();
        },
        handleCurDepositReceiveChange(pageNum) {
            this.pageNum = pageNum;
            this.loadTable();
        },

        // 详情弹窗口
        handleDetail(index, row) {
            this.detailDialog = { create: true, params: row };
            this.$nextTick(() => {
                this.detailDialog = { ...this.detailDialog, visible: true };
            });
        },
        handleDetailClosed() {
            this.detailDialog = { create: false, visible: false, params: {} };
        },

        // 添加弹窗口
        handleAdd() {
            this.addDialog = { create: true, visible: false };
            this.$nextTick(() => {
                this.addDialog = { create: true, visible: true };
            });
        },
        handleAddDone() {
            this.addDialog = { visible: false };
            this.loadTable();
        },
        handleAddClosed() {
            this.addDialog = { create: false, visible: false };
        },

        // 编辑弹窗口
        handleEdit(index, row) {
            this.editDialog = { create: true, visible: false, params: row };
            this.$nextTick(() => {
                this.editDialog = {  create: true, visible: true, params: row };
            });
        },
        handleEditDone() {
            this.editDialog = { create: true, visible: false, params: {} };
            this.loadTable();
        },
        handleEditClosed() {
            this.editDialog = { create: false, visible: false, params: {} };
        },

        handleDisable(index, row, status) {
            http.put(http.MOCK_DepositReceive_API_URL + 'demo/disable', { id: row.id, status: status }).then(req => {
                if (req.data.code == http.SUCCESS) {
                    this.loadTable();
                    this.showSuccess('禁用成功！');
                } else {
                    this.showError(req.data.msg);
                }
            });
        },
        handleDelete(index, row) {
            this.confirm('确认删除？', function () {
                http.delete(http.MOCK_DepositReceive_API_URL + 'demo/' + row.id).then(req => {
                    if (req.data.code == http.SUCCESS) {
                        this.loadTable();
                        this.showSuccess('删除成功！');
                    } else {
                        this.showError(req.data.msg);
                    }
                });
            });
        },
        handleDeleteAll() {
            if (this.$refs.curDepositReceiveTable.selection.length == 0) {
                this.showError('请选择要删除的信息！');
            } else {
                this.confirm('确认删除所选信息？', function () {
                    let idarr = [];
                    for (let i = 0; i < this.$refs.curDepositReceiveTable.selection.length; i++) {
                        idarr.push(this.$refs.curDepositReceiveTable.selection[i].id);
                    }
                    http.delete(http.MOCK_DepositReceive_API_URL + 'demo', { data: idarr }).then(req => {
                        if (req.data.code == http.SUCCESS) {
                            this.loadTable();
                            this.showSuccess('删除成功！');
                        } else {
                            this.showError(req.data.msg);
                        }
                    });
                });
            }
        },
        handleExport() {}
    }
}
</script>

<style scoped>
</style>
